import { render } from "./Layout.vue?vue&type=template&id=2a8351e6&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=js"
export * from "./Layout.vue?vue&type=script&lang=js"

import "./Layout.vue?vue&type=style&index=0&id=2a8351e6&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2326401477/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a8351e6"]])

export default __exports__